module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Backdrop to Evacuation")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("On 10 May 1940 Germany invaded France and the low countries of Holland, Belgium and Luxembourg. The attack involved three Army Groups advancing simultaneously: Army Group B, under "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Fedor von Bock, advanced through north eastern Belgium and a panzer assault, led by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Gerd von Rundstedt’s Army Group A, which attacked through the Ardennes, crossing the Meuse with the intention of cutting through the British and French armies. The third group, Army Group C under "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Wilhelm Ritter von Leeb, was tasked with breaking through the Maginot Line. Dubbed ‘the ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Matador’s Cloak’ by Basil Liddell Hart, the German plan was masterly in its simplicity and adopted the code word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fall Gelb")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fedor von Bock commanded Army Group B.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gerd von Rundstedt.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Phoney War was marked by a period of inactivity in France and Belgium. In this photograph cameraman Fred Bayliss (right) and his assistant are preparing to film for Paramount News.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Général Georges Blanchard.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up until 10 May Allied forces, under the overall command of Général Maurice Gamelin, had concentrated on extending the Maginot Line along the Belgian border, a period of some eight months of strategic inactivity that became known as the ‘Phoney War’. Gamelin’s plan to counter the expected German invasion was for French and British forces to cross the border into Belgium and occupy the line of the River Dyle, which runs roughly north and south about thirty miles east of Brussels. Given the operational code name Plan D, the British Expeditionary Force (BEF) were to deploy between Louvain and Wavre, with the French First Army, under Général Georges Blanchard, on their right in the Gembloux Gap. The Belgians, who were expected to hold their positions for several days, would then fall back into the gap between the left of the BEF and the right of Général Henri Giraud’s Seventh Army, who were to link-up with the Dutch via Breda.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Général Henri Giraud.")])])])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The BEF Command Structure")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In overall command of the BEF was 53-year-old John Vereker, Sixth Viscount Gort. Known more simply as Lord Gort, he was a highly decorated Grenadier Guards officer who had served in the First World War with some distinction; wounded on four occasions, he had been decorated with the Military Cross (MC) and the Distinguished Service Order (DSO) and two bars. His award of the coveted Victoria Cross (VC) came whilst he was commanding the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Battalion during the battle on the Canal du Nord in 1918.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0003-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Général Alphonse Georges with Lord Gort at Arras in May 1940.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0003-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir John Dill.")])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Commanding I Corps was General Sir John Dill, an individual who had served with distinction under Douglas Haig and succeeded General Sir Edmund Lieutenant General Michael Barker commanded I Corps after Dill was recalled. Ironside as Chief of the Imperial General Staff (CIGS) on 27 May 1940. After Dill’s recall, command of I Corps was passed to Lieutenant General Michael Barker. In command of II Corps was the energetic and able Lieutenant General Alan Brooke, a gunner who rose from lieutenant to ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("lieutenant colonel over the four years of the First World War. By the end of 1939 a third regular division had been formed – the 5"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Division – and in January 1940 the first of the Territorial divisions arrived, giving rise to the formation of III Corps under Lieutenant General Sir Ronald Adam.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0003-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lieutenant General Michael Barker commanded I Corps after Dill was recalled.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lieutenant General Alan Brooke.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lieutenant General Sir Ronald Adam.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Dyle Line")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The German advance of 10 May signalled the end of the ‘Phoney War’ and the move east by allied forces to the River Dyle. The main fighting force was headed by motorcycle units of the 4/Royal Northumberland Fusiliers and the Morris CS9 Armoured Cars of the 12"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Lancers and was carried out with little interference from enemy activity by the troop carrying companies of the Royal Army Service Corps (RASC). Gort’s plan was to place the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" and 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Divisions on the right flank and the 3"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("rd")]), _vm._v(" Division on the left, astride Louvain. By way of reserve, the 48"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" (South Midland) Division was ordered to move east of Brussels and the 4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" and 50"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" (Northumbrian) Divisions to the south. In addition, the 44"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" (Home Counties) Division was under orders to march to the Escaut south of Oudenaarde and the 42"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" (East Lancashire) Division placed on readiness to take up station to their right if required.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Events on the Meuse")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The campaign was essentially lost on 14 May when German panzer units of Army Group A stormed across the Meuse and headed for the channel ports along a twenty-five mile wide corridor of advance. This was the so-called ‘Sickle Cut’ through the Ardennes, which reached the Channel coast on 20 May, effectively cutting the Allied armies in two. These German advances late on 13 May had hastened a disorganized French retreat, which twenty-four hours later degenerated into a rout, opening up a dangerous gap that ultimately the French failed to fill. Général Georges Blanchard had little choice but to order a retirement to avoid being outflanked, which, in its turn, involved the British I Corps swinging their line ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("back from the Dyle for some six miles to the River Lasane in order to conform to the French retirement. Gamelin was replaced by the 73-year-old Général Maxime Weygand on 19 May, but by then the military disaster of 1940 was almost complete.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Général Maxime Weygand replaced Général Maurice Gamelin on 18 May as the Supreme Allied Commander.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("A Deteriorating Situation")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 19 May the strategic situation in the French First Army Group had become serious. To the north Allied forces had been forced back to the line of the River Escaut, while in the south the Panzer advance of Army Group A, which had broken through at Sedan, had created a large gap in Général André Corap’s Ninth French Army sector. German panzer divisions now threatened the right rear of the BEF, a threat which Gort temporarily countered by the creation of Petreforce in Arras and Macforce, which at the time was thinly spaced along the Haute Deûle and Scarpe Canals. Despite this, German commanders were quite rightly concerned that an Allied counter-stroke from both north and south of the River Somme could in effect turn the tables on the German advance, cut off their supply lines and trap them on the Channel coast.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("General Edmund Ironside.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Weygand Plan")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Weygand announced on 20 May that he was now Commander-in-Chief in all theatres of war and in order to break the German advance he planned a large counter offensive to smash through the panzer corridor and isolate the German armoured divisions on the Channel coast. This would be achieved by an attack from the north linking up with the newly formed French Third Army south of the Somme which, Weygand reported, had already recaptured Péronne, Albert and Amiens. This was blatantly untrue and, according to historian Gregory Blaxland, Weygand was living in a world of fantasy. The demands from Wegand for Gort to support the attack to the south brought the Chief of the Imperial General Staff (CIGS), General Edmund Ironside, to France to assess the situation and pressure Gort into attacking south in conjunction with the French. Convinced that a coordinated Allied attack could break the encirclement around the French First Army Group, both Ironside and Gort realised action was needed immediately if there was to be any chance that defeat was to be turned into victory. Gort still firmly believed that the gap in André Corap’s Ninth French Army sector must be closed if disaster was to be prevented. But, as he explained to Ironside, this was an undertaking that the French had ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("to initiate from the south, as all the BEF’s divisions – except two, which were at Arras with Frankforce - were committed to defending the line of the Escaut.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Frankforce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Frankforce was formed on 20 May [the same day that German forces reached the channel coast] and placed under the command of Major General Harold Franklyn, who commanded the 5"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Division. On 21 May a counter-stroke, comprising two infantry battalions from 151 Brigade, 50"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Division, and two battalions of tanks from 1 Army Tank Brigade, took place south of Arras against the tightening hold that was surrounding the British garrison. Although the counter-stroke was supported by sixty tanks of the French 3"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("rd")]), _vm._v(" Light Mechanized Division (3/DLM) from Général René Prioux’s Cavalry Corps, the promise made by Général Gaston-Henri Billotte, who agreed to support the British operation with an attack by two divisions from Général René-Félix Altmayer’s V Corps, never materialised.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Whether this was intended to be part of a much larger thrust is still unclear, as it appears that Gort was still harbouring the notion of supporting a French counter attack with the two divisions deployed along the Scarpe valley. That said, the Arras attack did enable the British to tighten their hold on Arras – albeit temporarily – and, as is often cited, built doubts in the minds of German High Command as to the speed of their advance. After the war von Rundstedt admitted that the Arras ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("counter-stroke came at a critical moment and ‘for a short time it was feared the panzer divisions would be cut off before the infantry divisions could come up to support them’. The delay imposed by the Frankforce counter-stroke certainly allowed reinforcements to be shipped over to Boulogne on 22 May – a lesson that was repeated at Calais – postponing the move of three panzer divisions towards Dunkerque until 27 May; by which time a more robust defence of the port had been organized to cover the evacuation. In checking the German advance it also added a vital twenty-four hours to the time available for the fortification and defence of the Canal Line. The counter-stroke at Arras is looked at in detail in the Battleground Europe publication, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frankforce and the Defence of Arras 1940")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The counter-stroke at Arras on 21 May achieved the element of surprise and caused widespread alarm amongst the German High Command. Pictured is the British Matilda Mark 1 tank, which was in production until August 1940.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, in reality the counter-stroke at Arras was much too weak to be a serious threat; but it did delay the German advance and inflicted significant losses on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalmajor")]), _vm._v(" Erwin Rommel’s 7"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division. But with Arras still surrounded and likely to fall at any time, Gort gave orders for the British to disengage from Arras on the night of 23 May, an action that must have raised the prospect of an eventual evacuation from the Channel ports.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Halt Order of 21 May")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Certainly Rommel’s exaggerated claims of being attacked by five divisions at Arras did much to fuel the expectation of a future allied counter attack within the ranks of German Supreme High Command (OKH) and contributed to two halt orders and, ultimately, the escape of the BEF from Dunkerque. It is highly likely that without this twenty-four hour intervention the famous Hitler Halt Order of 24 May would not have ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("the effect it did, as Dunkerque would have already been in German hands. It is a sad fact that the Allies were too weak and disorganized to take advantage of the bruised momentum of Rommel’s division at Arras. Had they been able to make a combined attack from both north and south of the Somme, the panzers may well have been cut off from their supply lines and become isolated along the Channel coast. Whilst it was clear to a number of allied observers that the counter attack was not going to take place, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("threat")]), _vm._v(" of such an attack led to the order to halt the advance of the panzer divisions on 21 May. However, at this critical juncture in the Dunkerque story, the threat to the panzer divisions no longer came from a counter attack but from the simple fact that the BEF "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("might")]), _vm._v(" reach the channel ports before the Germans. It was a notion that had already crossed the mind of the British, who responded with a transfer of troops from the British mainland to Boulogne and Calais in order to block the German advance towards Dunkerque.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Erwin Rommel pictured with his driver in France during May 1940.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Boulogne and Calais")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was not until the evening of 21 May that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("General der Panzertruppen")]), _vm._v(" Heinz Guderian and his XIX Panzer Corps was ordered to move north and capture the Channel ports. His immediate plan was for the 10"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division to move on Dunkerque, the 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Panzer Division to seize Boulogne and the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Panzer Division to advance on Calais. Then, at the crucial moment, perhaps with the taste of the Arras Counterstroke still in his mind, von Rundstedt held back the 10"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division, withdrawing them from Guderian’s command and placed them in reserve. Although the 10"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division was restored to Guderian’s command on 22 May and redirected to Calais, the damage had already been done and the opportunity of seizing the Channel ports and cutting off the BEF had evaporated. It took the 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Panzer Division three days to capture Boulogne, with the infantry finally overwhelming the garrison on 25 May; and even longer to take Calais, which was captured on 26 May.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Heinz Guderian.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Canal Line")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Gort’s great fear of the Germans driving forward behind his right flank was becoming a reality and, with the BEF now fighting on two fronts, his answer took the form of a number of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ad-hoc")]), _vm._v(" battle groups, tasked with specific duties of defence. The line to be defended followed the canalized River Aa from Gravelines on the Channel coast, through St-Omer and La ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Bassée, to Raches, six miles north east of Douai, and followed the old line of French fortified towns, which had already played a significant part in French military history. The Canal Line was the only natural barrier that stood any possibility of hindering the armoured advance of Army Group A from driving into the rear of the BEF.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Defending the Canal Line")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The formation of improvised forces is a feature of Gort’s conduct of the campaign and possibly had its origins in the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael")]), _vm._v(" offensive of March 1918, where Grover’s Force on the Fifth Army front was one of the first of these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ad hoc")]), _vm._v(" groups to be put into the line in a desperate bid to stem the German advance. Gort’s adoption of hastily organised forces came under some criticism as many of the units involved were badly equipped, lacked battlefield experience and had little or no opportunity to make sound administrative arrangements. However, in reality there was little alternative; until the main BEF retired from the Escaut, the regularly organised and equipped infantry divisions were fully committed and none could be freed for the protection of the flank and rear. It was hoped that the defence these groups put up would be enough to deter von Rundstedt by making him hesitate before committing his armour. In the event it was not only the watery Canal Line which delayed the panzers, but the Halt Order of 24 May.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Noel Mason-Mcfarlane.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first of these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ad hoc")]), _vm._v(" forces was the largely ineffective Macforce, under Major General Noel Mason-Macfarlane. Created on 17 May, it was initially ordered to hold the line of the River Scarpe between Raches and St-Amand before it eventually moved north and was disbanded at Cassel on 25 May. Gort created three further formations, under the names of Polforce, Usherforce and Rustyforce, each with specific orders to hold the line of the canals from Gravelines to Raches. His choice of which units to deploy relied very much on availability, hence the mix and match approach to defence that was evident at the main crossing points south of Gravelines. Full details of the intense fighting on the Canal Line can be found in the Battleground Europe volume entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Canal Line 1940")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The French First Army at Lille")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The defence of the city took place from 28 to 31 May 1940 and involved about 40,000 men of the First Army, under the command of Général Jean-Baptiste Molinié. Fortunately Général Benoît-Léon de la Laurencie ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("managed to extract the French III Corps and join the British I Corps in their withdrawal to the coast, leaving the French IV and V Corps to fight the 4th Panzer Division, 5th Panzer Division and 7th Panzer Division and four infantry divisions: 11th Division, 217th Division, 253rd Division and 267th Division. The Germans had to fight their way through the suburbs as the French held on in some of the most vicious street fighting of the campaign. The commander of the 40"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Artillery Regiment, Lieutenant Colonel Justin Dutrey, committed suicide in the Potié Brewery rather than surrender. In honour of the defenders of Lille and its suburbs, 35,000 men of the garrison were allowed by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("General der Infantrie")]), _vm._v(" Alfred Wäger to parade in the main square of Lille with their weapons – without ammunition - on 1 June, where he took the salute. As a consequence of the tenacious French defence of Lille, the BEF and the remaining units of the First Army were able to retreat into the Dunkerque perimeter.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The French First Army at Lille were allowed to keep their weapons in recognition of their courageous stand. Here they march past their German captors, who salute their bravery.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Halt Order of 24 May")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Known more generally as the Hitler Halt Order, which was sent to all German units west of the Canal Line, it remains one of the most hotly debated issues of the Second World War. On 24 May German forces were ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("within ten miles of Dunkerque, the only remaining port north of the Somme River open to the evacuation of the BEF. The leading elements had already crossed the Aa Canal and there were no British or French troops capable of stopping the German panzers from denying the port to the British and trapping about one million Allied troops in a rapidly reducing pocket of resistance. Hitler was on the threshold of a monumental victory and yet, astonishingly, OKH issued the order to halt the advance at 12.45 on 24 May. A furious Heinz Guderian later wrote that:")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "block"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We were stopped within sight of Dunkerque! We watched the Luftwaffe attack. We also saw the great armada of great and little ships by means of which the British were evacuating their forces")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Adolf Hitler gave his authority to the halt order of 24 May.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Loitering behind the order was the rising crescendo of disagreements between OKH and the officer corps, which escalated on 23 May, culminating in the removal of the Fourth Army from Army Group A and transferring it to Army Group B. In simple terms this meant that from 8.00pm on 24 May all panzer divisions would take their orders from von Bock and von Rundstedt would be concerned only with flank protection along the Somme. Hitler was furious and immediately rescinded the order, his anger focussing not only on the fact it had been made without his approval but because he, too, had feelings of anxiety regarding the exposed nature of the panzer thrust and shared von Rundstedt’s desire for the infantry to close the gap between them and the panzers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Hitler gave von Rundstedt complete freedom with regard to the length of the stop, giving additional weight to von Rundstedt’s view that Army Group A would be needed for the eventual swing south of the Somme and the capitulation of the trapped French Army. It was also von Rundstedt’s opinion that the remnants of the BEF could in fact be finished off by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Fedor von Bock’s Army Group B and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luftwaffe")]), _vm._v(" and it was not until the afternoon of 26 May that Hitler gave permission for the advance on Dunkerque to be continued. Whatever the reasons behind the Halt Order it was a very costly mistake; even though he tried later to put all the blame on Hitler, the chief architect of the order was the wily von Rundstedt, upon whose head must lie the responsibility for ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("much of the ultimate failure of German forces to achieve the total destruction of the BEF.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map_01"
    }
  }, [_vm._v("A map illustrating the British withdrawal to Dunkerque.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Dunkerque Corridor")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Valuable time was gained from the Hitler Halt Order, giving the Allies the opportunity to create a defensive corridor that the BEF could use to reach Dunkerque. On either side of the corridor, to slow down, and temporarily hold back the German advance, strong points were established in key towns and villages such as Cassel and Wormhout. French support for this plan was essential and it was agreed that the southern end of the corridor would be held by the French First Army. Historians agree that the evacuation would never have been as successful as it was had it not been for the so-called forgotten heroes of Dunkerque – British and French soldiers who were left behind to allow the bulk of the BEF to be rescued. Tragically, only a small proportion of those who stood and fought made it back to the evacuation beaches: most were killed, wounded or taken prisoner.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Belgian Surrender")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The Belgian surrender came into effect at 4.00am on 28 May. Recriminations abounded, with the British and French claiming the Belgians had betrayed the alliance. In Paris, the French Prime Minister, Paul Reynaud, denounced Leopold’s surrender, and the Belgian Prime Minister, Hubert Pierlot, informed the Belgians that Leopold had ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("taken action against the unanimous advice of the government and, as a result, the King was no longer in a position to govern. The argument focussed on the fact that the Belgians had not given any prior warning that their situation was so serious as to capitulate. Such claims were largely unjust. The Allies had known, and admitted it privately on 25 May through their contact with the Belgians, that the latter were on the verge of collapse. But, regardless of who or what was to blame, the Belgian capitulation opened up a large gap on the eastern flank, prompting Gort immediately to dispatch 143 Brigade and the 5"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" and 50"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Divisions to defend his right flank against the inevitable advance of the German Sixth Army. This move finally eradicated any further notion that may have still been lurking in Gort’s mind of a counter attack to link up with French forces south of the Somme. Historians feel that this deployment to the Ypres-Comines Canal saved the BEF from a German thrust to take Nieuport [now Nieuwpoort] and La Panne [now De Panne] and ultimately Dunkerque itself. The battle on the Ypres-Comines Canal almost certainly saved the BEF from annihilation.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Leopold III, King of the Belgians.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40587fdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter_01.vue
// module id = 84
// module chunks = 0